import { ProductController, UserController } from "controllers";

/**
 * helper function, used in
 * `swap_item` & `add_item`
 * @param {*} param0
 * @returns
 */
const createLogPayload = ({ customer, box }) => {
    const { shipment_week, return_date } = box;

    return {
        addedToBox: new Date().getTime(),
        boxID: box.id,
        processedReturn: null,
        toStorage: null,
        userID: customer.id,
        userEmail: customer.email,
        shipment_week,
        return_date
    };
}

/**
 *
 * @param {*} customer
 * @param {*} box
 * @param {*} item
 */
const deleteItem = async (customer, box, item) => {
    await UserController.deleteUserBoxItems(customer.id, box.id, item.id)

    const payload = { currentUser: null, currentBox: null, status: "available" }
    await ProductController.editProduct(item.barcode, payload);
    await ProductController.deleteProductLog(item.barcode, box.id);
}

/**
 *
 * @param {*} product new product to add
 * @param {*} customer
 * @param {*} box
 * @param {*} item the old one
 */
const swapItem = async (product, customer, box, item) => {
    const { barcode, name, imageURLs } = product;

    let { feedback } = box;
    if (feedback === undefined) { feedback = "" };

    const newItem = { ...item, feedback, barcode, name, description: name, imageURL: imageURLs[0] };
    await UserController.createUserBoxItem(customer.id, box.id, newItem);

    const oldProduct = await ProductController.getProductByBarcode(item.barcode);
    await ProductController.editProduct(barcode, { currentBox: box.id, currentUser: customer.id, status: oldProduct.status });

    // first check if box has feedback
    if (box.feedbackSaved) {
        const otherCollectionsToUpdate = ["liked_items", "unliked_items",
            "too_big", "too_small", "kept1month", "kept6months"];

        const newBoxItem = await UserController.getUserBoxItemByFieldValue(customer.id, box.id, 'barcode', barcode);
        const collectionsPayload = { documentID: newBoxItem.id, imageURL: imageURLs[0] };
        for (const col of otherCollectionsToUpdate) {
            const result = await UserController.getUserFeedbackCollections(customer.id, col, item.id);
            await UserController.setUserFeedbackCollections(customer.id, result.collection_name, result.id, collectionsPayload);
        }
    }

    const oldProductLog = await ProductController.getLogByBoxId(item.barcode, box.id);
    delete oldProductLog.id; delete oldProductLog.barcode;
    const logPayload = { ...oldProductLog, addedToBox: new Date().getTime() };
    await ProductController.createProductLog(barcode, box.id, logPayload);

    await deleteItem(customer, box, item);

    return newItem;
}

/**
 * @param {*} product
 * @param {*} item
 * @param {*} customer
 * @param {*} box
 */
const addItem = async (product, customer, box) => {

    const items = await UserController.getUserBoxItems(customer.id, box.id);
    const serial = Math.max.apply(Math.max, items.map(i => i.serial)) + 1;

    const { barcode, name, imageURLs } = product;
    const productPayload = { currentUser: customer.id, currentBox: box.id, status: "at_customer" };


    await ProductController.editProduct(barcode, productPayload);

    const logPayload = createLogPayload({ customer, box });
    await ProductController.createProductLog(barcode, box.id, logPayload);

    const itemPayload = {
        feedback: "", serial,
        status: "at_customer",
        barcode, boxId: box.id,
        description: name, name, imageURL: imageURLs[0]
    };
    await UserController.createUserBoxItem(customer.id, box.id, itemPayload);

    return itemPayload;
}

const addFeedback = async ({ customer, box, feedback }) => {
    const payload = { extra_feedback: feedback };
    await ProductController.setFeedBack(payload, customer.id, box.id);
}

/**
 * delete box
 * @param {*} param0
 */
const deleteBox = async ({ customer, box }) => {
    const items = await UserController.getUserBoxItems(customer.id, box.id);
    for (const item of items) {
        await deleteItem(customer, box, item);
    }

    await UserController.deleteUserBox(customer.id, box.id);
}

/**
 * change a box for not_picked_up
 * @param {*} param0
 */
const setNotPickedUp = async ({ customer, box }) => {
    const items = await UserController.getUserBoxItems(customer.id, box.id);
    for (const item of items) {
        await deleteItem(customer, box, item);
    }
    // Adding not_picked_up from the market
    const product = await ProductController.getProductByBarcode((customer.country === 'Sweden') ? "not_picked_up" : "not_picked_up_fr");

    const itemPayload = {
        barcode: product.barcode,
        name: product.name, serial: 1,
        status: "not_picked_up",
        boxId: box.id,
        description: product.name,
        imageURL: product.imageURLs[0]
    };
    await UserController.createUserBoxItem(customer.id, box.id, itemPayload);
    // Box status will be "not_picked_up" and feedback_saved to True
    const payload = {
        status: "not_picked_up",
        declared_not_picked_up: +new Date(),
        feedbackSaved: true
    }
    await ProductController.updateBoxInfo(customer.id, box.id, payload)
}

/**
 * edit date
 * @param {*} param0
 */
const editDate = async ({ customer, box, newDate }) => {
    const payload = {
        status: "at_customer",
        return_date: newDate
    }

    await ProductController.updateBoxInfo(customer.id, box.id, payload)
}

export { deleteItem, swapItem, addItem, addFeedback, deleteBox, setNotPickedUp, editDate };
